import Vue from 'vue'
import './plugins/fontawesome'
import App from './App.vue'
import VueCookies from 'vue-cookies'
import Toasted from 'vue-toasted';
import VuejsDialog from "vuejs-dialog"

import 'vuejs-dialog/dist/vuejs-dialog.min.css';

Vue.use(VueCookies, { expires: '30d'})
Vue.use(Toasted, { position: 'bottom-right', duration: 5000})
Vue.use(VuejsDialog, {
  cancelText: 'Fechar',
  okText: 'Confirmar',
})

//import vSelect from "vue-select";

// VUE-SELECT
//Vue.component("v-select", vSelect);
//import "vue-select/dist/vue-select.css";

// VUE-ROUTER
import router from './routes'

// FULLPAGE
import VueFullPage from 'vue-fullpage.js'
Vue.use(VueFullPage)


import money from 'v-money'

Vue.use(money)


// BOOTSTRAP-VUE
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import './services/cryptojs-aes.min.js'
import 'bootstrap-vue/dist/bootstrap-vue.css'


import store from './store'



// VUE-FONTAWESOME
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, } from '@fortawesome/vue-fontawesome'
import { faSearch, faUser, faEnvelope, faPhone, faComment, faPen, faRedoAlt, faHandHoldingUsd, faShoppingCart, faShoppingBasket, faSignOutAlt, faAddressCard, faPlusSquare as fasPlusSquare, faSlidersH } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope as farEnvelope } from '@fortawesome/free-regular-svg-icons'
library.add(faSearch, faUser, faEnvelope, faPhone, faComment, farEnvelope, faPen, faRedoAlt, faHandHoldingUsd, faShoppingCart, faShoppingBasket, faSignOutAlt, faAddressCard, fasPlusSquare, faSlidersH)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

Vue.prototype.$eventBus = new Vue();

// import BootstrapSideBar from 'b-sidebar';
// Vue.use(BootstrapSideBar);


/* FILTROS */
Vue.filter('formatar_data', function (value) {
  if(!value) return ''
  let data = new Date(value.split('-'))
  let dia  = data.getDate().toString(),
  diaF = (dia.length == 1) ? '0'+dia : dia,
  mes  = (data.getMonth()+1).toString(),
  mesF = (mes.length == 1) ? '0'+mes : mes,
  anoF = data.getFullYear();
  return diaF+"/"+mesF+"/"+anoF;
});

Vue.filter('formatar_documento', function (value) {
  if (value == null) {
      return '';
  } else {
      let v = value;
      //Remove tudo o que não é dígito
      v = v.replace(/\D/g, "");
      if (v.length < 14) { //CPF
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      } else { //CNPJ
          v = v.replace(/^(\d{2})(\d)/, "$1.$2");
          v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
          v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
          v = v.replace(/(\d{4})(\d)/, "$1-$2");
      }
      return v;
  }
});

Vue.filter('formatar_documento_exibe_parcial', function (value) {
  if (value == null) {
      return '';
  } else {
      let v = value;
      // Remove tudo o que não é dígito
      v = v.replace(/\D/g, "");
      if (v.length < 14) { // CPF
          v = v.replace(/^(\d{5})/, "XXXXX");
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      } else { // CNPJ
          v = v.replace(/^(\d{12})/, "XXXXXXXXXXXX");
          v = v.replace(/^(\d{2})(\d)/, "$1.$2");
          v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
          v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
          v = v.replace(/(\d{4})(\d)/, "$1-$2");
      }
      return v;
  }
});

Vue.filter('money', function (value) {
  if(!value || value === '.00') return 'Valor não informado'
  return value
})
Vue.filter('upper', function (value, len = 15) {
  return value.length > len ? value.toUpperCase().substring(len, 0) + "..." : value.toUpperCase();
})



Vue.config.productionTip = false

import API from './services/api';
import { useDevice } from './services/device_service';
import axios from "axios";

const device = useDevice();
import loader from './components/loader.vue';
Vue.component('loader', loader);
const isDevice = /(iPhone|iPod|iPad|Android|webOS|BlackBerry|Windows Phone)/i.test(navigator.userAgent);
new Vue({
  router,
  data() {
    return {
      isDevice: isDevice,
      device: device,
      userLogged: false,
    };
  },
  methods: {
    clearLocalStorage(){
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('lhwvzhds3');
      localStorage.removeItem('t178w3gm3');
      localStorage.removeItem('pxppwiru9');
      localStorage.removeItem('tokenTermo');
      localStorage.removeItem('usrCpf');
      localStorage.removeItem('usrEmail');
      localStorage.removeItem('usrName');
      localStorage.removeItem('libAnuencia');
      localStorage.removeItem('libProcuracao');
      localStorage.removeItem('nm_nr_documento_cert');
      localStorage.removeItem('sg_tipo_documento');
      localStorage.removeItem('SSL_CLIENT_S_DN');
      localStorage.removeItem('SSL_CLIENT_S_DN_CN');
      localStorage.removeItem('SSL_CLIENT_V_END');
      localStorage.removeItem('SSL_CLIENT_V_START');
      localStorage.removeItem('nm_thumbprint');
      localStorage.removeItem('nm_thumbprint_sha256');
      localStorage.removeItem('nm_tipo_certificado');
    },
    isLoggedGov(){
      let govToken = localStorage.getItem('pxppwiru9');
      return (govToken?true:false);
    },
    isLogged() {
      this.userLogged = false;
      localStorage.removeItem('tokenTermo');
      //const token = localStorage.getItem('jwtToken')
      var token = sessionStorage.getItem('jwtToken');
      var keepAlive = sessionStorage.getItem('keepAlive');
      let govToken = sessionStorage.getItem('pxppwiru9');
      return new Promise((resolve, reject) => {
        if(govToken != undefined && govToken != null && govToken != 'undefined'){
          var logViaGov = true
          API.get(`auth/checkGov?token=${token}&govToken=${govToken}`).then((res) => {
            if(res.data.logged === true) {
              localStorage.setItem('pxppwiru9',res.data.pxppwiru9)
              sessionStorage.setItem('pxppwiru9',res.data.pxppwiru9)
              localStorage.setItem('lhwvzhds3',res.data.lhwvzhds3)
              API.get(`usuario/termo-aceite-site/check?token=${token}`).then((resAceite) => {
                localStorage.setItem('tokenTermo', resAceite.data.aceite);
              }).catch((errorAceite)=>{
                console.log(errorAceite)
              });
              this.userLogged = true;
              resolve(true)
            } else {
              localStorage.removeItem('pxppwiru9');
              sessionStorage.removeItem('pxppwiru9');
              localStorage.removeItem('t178w3gm3');
              sessionStorage.removeItem('t178w3gm3');
              localStorage.removeItem('lhwvzhds3');
              localStorage.removeItem('jwtToken');
              govToken = null
              token = false
              this.userLogged = false;
              reject(false)
            }
          })
          .catch((error)=>{
            localStorage.removeItem('jwtToken');
            localStorage.removeItem('pxppwiru9');
            localStorage.removeItem('t178w3gm3');
            localStorage.removeItem('lhwvzhds3');
            token = false
            govToken = null
            this.userLogged = false;
            reject(false)
          }); 
        }
        if(token != undefined && token != null && token != 'undefined'){
          API.get(`auth/check`).then((res) => {
            if(res.data.logged === true) {
              if(logViaGov && govToken === null) {
                localStorage.removeItem('jwtToken')
                this.userLogged = false;
                reject(false)
              }
              else {                
                API.get(`usuario/termo-aceite-site/check`).then((resAceite) => {
                  localStorage.setItem('tokenTermo', resAceite.data.aceite);
                }).catch((errorAceite)=>{
                  console.log(errorAceite)
                });
                this.userLogged = true;
                resolve(true)
              }
            } else {
              if(logViaGov && govToken === null) localStorage.removeItem('jwtToken')
              else if(keepAlive){
                this.userLogged = true;
                resolve(true);
              }
              this.userLogged = false;
              reject(false)
            }
          }).catch(() => {
            if(keepAlive){
              API.post("auth/touch", { token: token }).then((res) => {
                let dataTouch = res.data;
                localStorage.setItem("jwtToken", dataTouch.token);
                sessionStorage.setItem("jwtToken", dataTouch.token);
                localStorage.setItem("usrName", dataTouch.name);
                localStorage.setItem("usrEmail", dataTouch.email);
                localStorage.setItem("usrCpf", dataTouch.cpf);
                this.userLogged = true;
                resolve(true);
              }).catch((error) => {
                console.log(error)
                this.userLogged = false;
                reject(false);
              });
            }
            else{
              if(logViaGov && govToken === null) localStorage.removeItem('jwtToken')
              localStorage.removeItem('jwtToken')
              this.userLogged = false;
              reject(false)
            }
          })
        }
        else {
          this.userLogged = false;
          reject(false)
        }
      })
    },
    loginSSO(cpf, senha, tok, client_id) {
      sessionStorage.removeItem('pxppwiru9');
      localStorage.removeItem('pxppwiru9');
      sessionStorage.removeItem('t178w3gm3');
      localStorage.removeItem('t178w3gm3');
      localStorage.removeItem('lhwvzhds3');
      return new Promise((resolve, reject) => {
        API.post("auth/login-sso", { cpf: cpf, senha: senha, tokenCaptcha : tok, client_id : client_id}).then((res) => {
          resolve(res.data)
        }).catch((error) => {
          reject(error.response.data)
        })
      })
    },
    touch(token){
      API.post("auth/touch", { token: token}).then((res) => {
        let dataTouch = res.data;
        localStorage.setItem("jwtToken", dataTouch.token);
        sessionStorage.setItem("jwtToken", dataTouch.token);
        localStorage.setItem("usrName", dataTouch.name);
        localStorage.setItem("usrEmail", dataTouch.email);
        localStorage.setItem("usrCpf", dataTouch.cpf);
      }).catch((error) => {
        console.log(error)
      });
    },
    login(cpf, senha, tok) {
      sessionStorage.removeItem('pxppwiru9');
      localStorage.removeItem('pxppwiru9');
      sessionStorage.removeItem('t178w3gm3');
      localStorage.removeItem('t178w3gm3');
      localStorage.removeItem('lhwvzhds3');
      return new Promise((resolve, reject) => {
        API.post("auth/login", { cpf: cpf, senha: senha, tokenCaptcha : tok}).then((res) => {
          resolve(res.data)
        }).catch((error) => {
          reject(error.response.data)
        })
      })
    },
    loginGov(code) {
      return new Promise((resolve, reject) => {
        API.post("auth/loginGov", { code: code}).then((res) => {
          localStorage.setItem("jwtToken", res.data.token)
          sessionStorage.setItem("jwtToken", res.data.token)
          localStorage.setItem("tokenTermo", res.data.tokenTermo)
          localStorage.setItem("usrName", res.data.name)
          localStorage.setItem("usrEmail", res.data.email)
          localStorage.setItem("usrCpf", res.data.cpf)
          localStorage.setItem('pxppwiru9',res.data.pxppwiru9)
          sessionStorage.setItem('pxppwiru9',res.data.pxppwiru9)
          localStorage.setItem('t178w3gm3',res.data.pxppwiru9)
          sessionStorage.setItem('t178w3gm3',res.data.pxppwiru9)
          localStorage.setItem('lhwvzhds3',res.data.lhwvzhds3)
          // alert('aee')
          // resolve(res.data);
          if(res.data.token != null && res.data.token.length == 0)this.$router.push({ name: "cadastro" })
          else 
          {
            if(res.data.ic_atualizacao_termo != 1)this.$router.push('/termo-aceite-site')
            else this.$router.push({ name: "painel" });
          }
        }).catch((error) => {
          reject(error.response.data)
        })
      })
    },
    logout() {
      localStorage.removeItem('jwtToken')
      sessionStorage.removeItem('jwtToken')
      sessionStorage.removeItem('keepAlive')
      if(localStorage.getItem('pxppwiru9') != undefined
      && localStorage.getItem('pxppwiru9') != null){
        sessionStorage.removeItem('pxppwiru9');
        localStorage.removeItem('pxppwiru9');
        sessionStorage.removeItem('t178w3gm3');
        localStorage.removeItem('t178w3gm3');
        localStorage.removeItem('lhwvzhds3');
        window.location.href = 'https://sso.acesso.gov.br/logout?post_logout_redirect_uri=https%3A%2F%2Fsite.cenprotnacional.org.br'
      } else {
        setTimeout(() => {
          location.href = '/'
        }, 1000)
      }
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    setCookie(cname, cvalue, exminutes = null) {
      if(exminutes !== null){
        const d = new Date();
        d.setTime(d.getTime() + (exminutes*60*1000));
        var expires = "expires="+ d.toUTCString() + ";";
      }
      else expires = '';
      document.cookie = cname + "=" + cvalue + ";" + expires + "path=/";
    },
    deleteCookie(cname){
      let expires  = "expires=" + new Date(0).toUTCString() + ";";
      document.cookie = cname + "=; " + expires + "path=/;";
    }
  },
  computed:{
    manterLogado(){
      return (sessionStorage.getItem('keepAlive') != undefined)
    }
  },
  created(){
    this.userLogged = false;
    if(sessionStorage.getItem('jwtToken') != undefined && sessionStorage.getItem('jwtToken') != null)
    {
      setTimeout(()=>{
        if(!this.manterLogado){
          sessionStorage.removeItem('jwtToken')
          location.href = '/'
        }
        },3600000)
      //3600000 = 1 hr
    }
  },
  store,
  render: h => h(App)
}).$mount('#app')
